import { useEffect, useRef } from "react";

import type { MBCUIMessage } from "../types/mbc-chat.types";
import type { MbcUploadBinding } from "./parts/UploadPromptPart";

import { MBCMessageBubble } from "./MBCMessageBubble";

type MBCMessageListProps = {
  isInteractiveDisabled: boolean;
  isStreaming: boolean;
  messages: MBCUIMessage[];
  onReview: () => void;
  onSelectChoice: (label: string) => void;
  upload?: MbcUploadBinding;
};

export function MBCMessageList({
  isInteractiveDisabled,
  isStreaming,
  messages,
  onReview,
  onSelectChoice,
  upload,
}: MBCMessageListProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const lastAssistantMessageId = [...messages]
    .reverse()
    .find((message) => message.role === "assistant")?.id;

  useEffect(() => {
    const container = containerRef.current;

    if (!container) return;
    container.scrollTop = container.scrollHeight;
  }, [messages, isStreaming]);

  return (
    <div
      className="flex flex-1 flex-col gap-lg overflow-y-auto px-3xl py-xl"
      ref={containerRef}
    >
      {messages.map((message) => (
        <MBCMessageBubble
          isInteractiveDisabled={isInteractiveDisabled}
          isLastAssistantMessage={
            message.role === "assistant" &&
            message.id === lastAssistantMessageId
          }
          key={message.id}
          message={message}
          onReview={onReview}
          onSelectChoice={onSelectChoice}
          upload={upload}
        />
      ))}

      {isStreaming ? (
        <div className="flex items-center gap-sm text-sm text-text-tertiary">
          <span className="inline-flex size-2 animate-pulse rounded-full bg-fg-brand-primary" />
          AI is typing...
        </div>
      ) : null}
    </div>
  );
}
